import React from 'react';
import styled from 'styled-components';
import { css, Flex } from '@goodrx/matisse-react';
import { ComponentRenderer } from '@goodrx/x-core';
import { Section as DSMSection, SectionHeader } from '../../../../components/Section';
import { MarkdownCopy } from '../../../../components/MarkdownCopy';
const SubtitleContent = styled.div`
  ${({
  variant,
  greenEmphasis
}) => {
  return () => css`
      p:first-child {
        margin-top: 0;
      }
      *:last-child {
        margin-bottom: 0px;
      }
      ${variant === 'primary' ? 'p > a { color: white; text-decoration: underline;}' : null}
      ${greenEmphasis ? 'em { color: #00BC82; font-weight: bold;}' : null}
    `;
}};
`;
export const Section = ({
  className,
  componentMap,
  tabletBackgroundColor,
  mobileBackgroundColor,
  tabletDividerColor,
  mobileDividerColor,
  alternate,
  collapsed,
  greenEmphasis = false,
  mobileHeaderAlignmentOverride,
  displayTitle,
  subtitle,
  itemsCollection,
  footersCollection,
  variant
}) => {
  const {
    items
  } = itemsCollection || {
    items: []
  };
  const {
    items: footerItems
  } = footersCollection || {
    items: []
  };
  const sanitzedVariant = variant === 'primary' ? 'primary' : undefined;
  return /*#__PURE__*/React.createElement(DSMSection, {
    className: className,
    tabletBackgroundColor: tabletBackgroundColor || undefined,
    mobileBackgroundColor: mobileBackgroundColor || undefined,
    tabletDividerColor: tabletDividerColor || undefined,
    mobileDividerColor: mobileDividerColor || undefined,
    alternate: !!alternate,
    collapsed: !!collapsed,
    variant: sanitzedVariant
  }, displayTitle && /*#__PURE__*/React.createElement(SectionHeader, {
    title: displayTitle,
    subtitle: subtitle && /*#__PURE__*/React.createElement(SubtitleContent, {
      variant: sanitzedVariant,
      greenEmphasis: greenEmphasis
    }, /*#__PURE__*/React.createElement(MarkdownCopy, {
      source: subtitle
    })),
    standalone: !items.length,
    mobileHeaderAlignment: mobileHeaderAlignmentOverride || 'center'
  }), items.map(data => /*#__PURE__*/React.createElement(ComponentRenderer, {
    data: { ...data,
      inline: true
    },
    key: data.sys.id,
    componentMap: componentMap
  })), footerItems.length > 0 && /*#__PURE__*/React.createElement(Flex, {
    mt: {
      _: '24px',
      md: '48px'
    },
    justifyContent: "center",
    alignItems: "center"
  }, footerItems.map(data => /*#__PURE__*/React.createElement(ComponentRenderer, {
    data: { ...data
    },
    key: data.sys.id,
    componentMap: componentMap
  }))));
};